import { useUserRewardsTracker } from '@/api/user-rewards';
import { bonusRewardTypeColumns } from '@/constants/bonusRewardTypeColumns';
import {
  ErrorCard,
  LottieOrImage,
  TableGrid,
} from '@starsoft/common/components';
import { useLottiePlayer } from '@starsoft/common/hooks';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';

export default function BonusOverviewModalContent() {
  const { t } = useTranslation('bonus');

  const playerLottie = useLottiePlayer({
    path: '/gift-box-success.json',
  });
  const {
    trackers,
    isLoading: isLoadingUserRewardsTracker,
    error: errorUserRewardsTracker,
    refetch: refetchUserRewardsTracker,
  } = useUserRewardsTracker();

  if (errorUserRewardsTracker) {
    return (
      <div className={styles.container}>
        <ErrorCard
          error={errorUserRewardsTracker}
          refetch={refetchUserRewardsTracker}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <LottieOrImage
        lottie={playerLottie}
        image={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/kube/bonus/bonus-banner.png`}
        classList={{
          lottie: styles.container__lottie,
          image: styles.container__image,
        }}
      />
      <div className={styles.container__wrapper}>
        <div className={styles.container__title}>
          {t('bonus_overview_title')}
        </div>
        <div className={styles.container__description}>
          {t('bonus_overview_description')}
        </div>
      </div>
      <TableGrid
        rows={trackers ?? []}
        isLoading={isLoadingUserRewardsTracker}
        columns={bonusRewardTypeColumns}
      />
    </div>
  );
}
